import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';
import StatTile from '../../../components/atoms/StatTile';

// Plan verification panel (SCT-692 / mock 010): "here's how many routes /
// stops / drivers / vans you're supposed to have — does all of this look
// right?" Purely informational: drivers/vans needed are computed from the
// plan (1 driver + 1 van per route); the shortage warning lives with the
// headcount inputs that follow, where entered counts are compared against
// these needs.

const StyledDiv = styledComponent('div', {
  background: theme.colors.bgMuted,
  border: theme.borders.card,
  borderRadius: theme.radii.inner,
  marginBottom: theme.spacing.fieldGap,
  padding: theme.spacing.bodyPadding,

  '& .ps-title': {
    fontWeight: theme.fontWeights.semibold,
    color: theme.colors.text,
    marginBottom: theme.spacing.fieldGap,
  },
  '& .ps-grid': {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: theme.spacing.fieldGap,
  },
});

function displayCount(value) {
  return typeof value === 'number' ? String(value) : '—';
}

function PrepSummary({
  title,
  routesCount,
  stopsCount,
  driversNeeded,
  vansNeeded,
}) {
  return (
    <StyledDiv data-testid="prep-summary">
      <div className="ps-title">{title}</div>
      <div className="ps-grid">
        <StatTile
          value={displayCount(routesCount)}
          label="Routes"
          testId="ps-tile-routes"
        />
        <StatTile
          value={displayCount(stopsCount)}
          label="Stops"
          testId="ps-tile-stops"
        />
        <StatTile
          value={displayCount(driversNeeded)}
          label="Drivers needed"
          testId="ps-tile-drivers"
        />
        <StatTile
          value={displayCount(vansNeeded)}
          label="Vans needed"
          testId="ps-tile-vans"
        />
      </div>
    </StyledDiv>
  );
}

PrepSummary.propTypes = {
  title: PropTypes.string,
  routesCount: PropTypes.number,
  stopsCount: PropTypes.number,
  driversNeeded: PropTypes.number,
  vansNeeded: PropTypes.number,
};

PrepSummary.defaultProps = {
  title: 'Tomorrow’s plan — does this look right?',
  routesCount: null,
  stopsCount: null,
  driversNeeded: null,
  vansNeeded: null,
};

export default PrepSummary;
